import './style.css';
import { router } from './src/router.js';

// Initialize the router
router();
